import type { RecordDetailHeaderPresentation } from "@kontextwerk/web-sdk/ui/layout/recordDetail/types"
import { mdiAccountOutline, mdiOfficeBuildingOutline } from "@mdi/js"
import { archivePresentation } from "../../../../../../../_shared/_logic/archive-presentation"

/** Shown while the customer type is still unknown. */
export const customerRecordIcon = mdiAccountOutline

export const buildCustomerHeader = (
  customer: Customer,
  contactPoints: ContactPoint[],
): RecordDetailHeaderPresentation => {
  const fields: RecordDetailHeaderPresentation["fields"] = []
  const kind = { PERSON: "Privatperson", COMPANY: "Unternehmen" }[customer.type]

  if (kind) fields.push({ id: "kind", label: "Art", value: kind })

  for (const [kind, id, label] of [
    ["EMAIL", "email", "E-Mail"],
    ["PHONE", "phone", "Telefon"],
  ]) {
    const points = contactPoints.filter(
      (point) =>
        point.customer_id === customer.id &&
        point.organization_id === customer.organization_id &&
        point.kind === kind &&
        (!point.lifecycle_status || point.lifecycle_status === "ACTIVE") &&
        Boolean(point.value?.trim()),
    )
    const primary = points.filter((point) => point.is_primary)
    const values = [
      ...new Set((primary.length ? primary : points).map((point) => point.value.trim())),
    ]

    if (values.length === 1) fields.push({ id, label, value: values[0] })
  }

  return {
    icon: customer.type === "COMPANY" ? mdiOfficeBuildingOutline : customerRecordIcon,
    subtitle: customer.archived_at
      ? archivePresentation(customer.archived_at, customer.archive_reason)
      : undefined,
    fields,
  }
}
